import { useState, useEffect } from 'react'
import { ApolloError } from 'apollo-boost'

export interface ImportSummaryData {
  totalCount: number
  createdCount: number
  failedCount: number
}

export interface ImportSummaryHook {
  loading: boolean
  summary: ImportSummaryData
  error: ApolloError | null
}

export default function useImportSummary(
  id: string,
  summaryApi: (id: string) => Promise<ImportSummaryData>
) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<ApolloError | null>(null)
  const [summary, setSummary] = useState<ImportSummaryData>({
    totalCount: 0,
    createdCount: 0,
    failedCount: 0,
  })

  useEffect(() => {
    summaryApi(id)
      .then((summary) => {
        setLoading(false)
        setSummary(summary)
      })
      .catch((error: ApolloError | null) => {
        setError(error)
        setLoading(false)
      })
  }, [id, summaryApi])

  return { loading, error, summary }
}
